import _ from 'lodash';

import { ServiceClient } from '@services/coralservices/ServiceClient';
import IhmRemovalsService from 'IhmRemovalsService-coral-javascript-clients/jquery-client.js';

const client = new ServiceClient('IhmRemovalsService', IhmRemovalsService);

/**
 * IhmRemovalsServiceClient
 * This module is responsible for calling IhmRemovalsService APIs.
 *
 * Uses the jQuery ServiceClient pattern (cookie-based Midway auth via AWSSSLProxy).
 * For TypeScript client usage (recommended for new tools), use createTypeScriptClient()
 * directly in your tool with @amzn/sentry-fetch and @amzn/coral_com-amazon-ihmremovalsservice.
 */
export class IhmRemovalsServiceClient {
    /**
     * Classifies a single item for regulatory waste handling.
     */
    public static getWasteDetails(siteId: string, itemIdWithType: { itemId: string; idType: string }) {
        return IhmRemovalsServiceClient.sendRequest(
            'GetWasteDetails',
            {
                siteId,
                itemIdWithType,
            },
            siteId,
        );
    }

    /**
     * Records a regulated ASIN removal and publishes the event to WADM.
     */
    public static recordRegulatedAsinRemoval(
        siteId: string,
        itemIdWithType: { itemId: string; idType: string },
        quantityRemoved: number,
        removalTimestamp: string,
        toolName: string,
        associateId?: string,
        wasteBinLocation?: string,
    ) {
        return IhmRemovalsServiceClient.sendRequest(
            'RecordRegulatedAsinRemoval',
            {
                siteId,
                itemIdWithType,
                quantityRemoved,
                removalTimestamp,
                toolName,
                ...(associateId !== undefined && { associateId }),
                ...(wasteBinLocation !== undefined && { wasteBinLocation }),
            },
            siteId,
        );
    }

    private static sendRequest(operation: string, data: { [key: string]: any }, storeId: string) {
        const dataToSend: { [key: string]: any } = _.cloneDeep(data);
        return client.sendRequest(
            {
                operation,
                data: dataToSend,
            },
            storeId,
        );
    }
}
